import { useNavigate } from "@/lib/router";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useAuth } from "reactfire";

const useLogoutHandler = () => {
  const client = useQueryClient();
  const auth = useAuth();
  const navigate = useNavigate();

  const clearCacheOnLogout = () => {
    client.removeQueries({
      queryKey: ["user", "user-plan-data", "pricing-data"],
    });
  };

  const handleLogout = useCallback(() => {
    auth.signOut();
    toast.success("Logged out successfully");
    setTimeout(() => {
      client.removeQueries({
        queryKey: ["user", "user-plan-data", "pricing-data"],
      });
    }, 600);
    navigate("/auth");
  }, [auth, client, navigate]);

  return { clearCacheOnLogout, handleLogout };
};

export default useLogoutHandler;
